<template>
  <div class="container">
    <div id="sticker">
      <div id="stickerCon">
        <slot></slot>
      </div>
    </div>
    <!--<div id="footer">copyright@ by urovo</div>-->
  </div>
</template>

<script>
  export default {
    name: 'container',
    data () {
      return {}
    }
  }

</script>



// WEBPACK FOOTER //
// Container.vue?1ba9229a